import { oz } from '@weft/utils';
import { ApiDateSchema } from '../primitives';

export const CreatedEntitySchema = oz.object({
  id: oz.string(),
  createdAt: ApiDateSchema,
  updatedAt: ApiDateSchema,
});

export type CreatedEntity = oz.infer<typeof CreatedEntitySchema>;
